import mutations from './moduleGeneralMutations.js';
import actions from './moduleGeneralActions.js';

export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
};
